/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React from 'react';
import {
  Box,
  Typography,
  Grid,
  IconButton,
  Card,
  CardContent,
} from '@mui/material';
import {openUrl} from '@jobseeker/common-core/utils';
import Link from 'next/link';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {ABS_URL} from './env';
import {CompanyJobsLinkageUrlMapping} from './constants';
import {useWrappedTheme} from '@jobseeker/lotus/hooks';

interface Props {
  jobCategory: string;
  source: string;
}

interface CompanyJobListingSeoLinkagesProps {
  source: string;
}

export const getCompanyJobsLinkageUrl = (jobCategory: any) => {
  const categoryDomain = CompanyJobsLinkageUrlMapping[jobCategory];
  return `${ABS_URL}/${categoryDomain}`;
};

const CompanyListingCard: React.FC<Props> = ({jobCategory, source}) => {
  const jobsUrl = getCompanyJobsLinkageUrl(jobCategory);
  const locationUrl = `${jobsUrl}?source=${source}`;
  const theme = useWrappedTheme();

  return (
    <Link
      href={locationUrl}
      passHref
      target="_blank"
      style={{textDecoration: 'none', marginRight: '50px'}}
      onClick={e => {
        e.preventDefault();
        setTimeout(() => openUrl(locationUrl, '_blank'), 0);
      }}
    >
      <Card
        sx={{
          borderRadius: '8px',
          boxShadow: '0 10px 30px 0 rgba(0,0,0,.06)',
          border: '1px solid #ececec',
          backgroundColor: '#fff',
          transition: 'box-shadow 0.2s',
          '&:hover': {boxShadow: 'none'},
          padding: '20px !important',
          marginRight: '50px',
          height: {xs: 122, xl: 95},
        }}
      >
        <CardContent
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 1,
            padding: '0px !important',
          }}
        >
          <Box sx={{width: '300px'}}>
            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 300,
                color: '#000',
                fontFamily: 'Nunito Sans',
                textDecoration: 'none',
              }}
            >
              {jobCategory} Companies Jobs
            </Typography>
            <Typography
              sx={{
                fontSize: 16,
                fontWeight: 'bold',
                cursor: 'pointer',
                color: theme.palette.primary.main,
                fontFamily: 'Nunito Sans',
                textDecoration: 'none ',
              }}
            >
              View all jobs
            </Typography>
          </Box>

          <IconButton
            sx={{
              opacity: 0.3,
              height: '0.8em',
              width: '0.8em',
              fontSize: '0.8em',
            }}
          >
            <ArrowForwardIcon
              sx={{
                height: '0.7em',
                width: '0.8em',
              }}
            />
          </IconButton>
        </CardContent>
      </Card>
    </Link>
  );
};

const CompanyJobListingSeoLinkages: React.FC<
  CompanyJobListingSeoLinkagesProps
> = ({source}) => {
  return (
    <Box
      sx={{
        display: {xxs: 'none', md: 'block'},
        padding: '37px 28px 36px 68px',
        backgroundColor: '#fffaf0',
        marginTop: '26px',
        marginBottom: '80px',
      }}
    >
      <Typography
        sx={{
          fontSize: '32px',
          fontWeight: 200,
          marginBottom: 1.75,
          fontFamily: 'Nunito Sans',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <b>Explore jobs </b>&nbsp;based on trending domains
      </Typography>
      <Grid
        container
        spacing={2}
        justifyContent={{xxs: 'space-between', md: 'space-between'}}
      >
        <Grid item md={4}>
          <CompanyListingCard jobCategory="Product" source={source} />
        </Grid>
        <Grid item md={4}>
          <CompanyListingCard jobCategory="E-Commerce" source={source} />
        </Grid>
        <Grid item md={4}>
          <CompanyListingCard jobCategory="Fintech/EdTech" source={source} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CompanyJobListingSeoLinkages;
